<template>
  <layout>
    <all-events v-if="available"></all-events>
    <div v-else class="pt-4">
      <h3 class="text-center">{{ $t('effieciencyLoss.extension') }}</h3>
      <router-link
        class="nav-link px-0 col-sm-4 text-center mx-auto"
        :to="{ name: 'MarketFeatures' }"
      >
        <b-btn variant="primary" size="md">
          <span class="h4">{{ $t('effieciencyLoss.toFeatures') }}</span>
        </b-btn>
      </router-link>
    </div>
  </layout>
</template>

<script>
export default {
  name: 'EventsPage',
  components: {
    AllEvents: () => import('@/components/events/AllEvents'),
  },
  computed: {
    available() {
      return this.hasFeature('downtimes');
    },
  },
};
</script>
